// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3sPhK","actionsCol":"EnrolledClinics_actionsCol__1ZkVq"};